module.exports = __webpack_public_path__ + "static/logoIFSblackV2.e139d232.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logoIFSblackV2.png
// module id = 542
// module chunks = 114276838955818